import TTransfer from './transfer.vue'
export default TTransfer



// WEBPACK FOOTER //
// ./src/components/transfer/index.js